// extracted by mini-css-extract-plugin
export default {"rateContainer":"SyuuPT8xMjioTKeGhtwN","starsContainer":"KJJFcX7vcB_k7pUF0FN_","danger":"S1T9EPUBG6XsCNZnn0ty"};